import React from 'react';
import { Link } from 'react-router-dom';

function NavBar() {
  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="navbar__inner container">
        <Link to="/" className="navbar__brand" aria-label="The Month in Bath home">
          <img
            src="/logo.svg"
            alt="The Month in Bath logo placeholder"
            className="navbar__logo"
          />
          <span className="navbar__title">The Month in Bath</span>
        </Link>

        <div className="navbar__links">
          <Link to="/" className="navbar__link">Listen</Link>
          <Link to="/about" className="navbar__link">About Us</Link>
          <a
            className="navbar__link"
            href="mailto:monthinbath@gmail.com?subject=Contact%20from%20Month%20in%20Bath%20Website"
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;